export interface BaseObject {
  [key: string]: BaseObjectValue;
}

export type BaseObjectPrimitiveValue =
  | string
  | number
  | boolean
  | null
  | undefined;
export type BaseObjectValue =
  | BaseObjectPrimitiveValue
  | BaseObject
  | BaseObjectPrimitiveValue[];

/**
 * 视频宽高比枚举
 */
export enum AspectRatio {
  LANDSCAPE = "16:9",
  PORTRAIT = "9:16",
}
